<!DOCTYPE html>
@if (globalFortuneMapData$ | async; as globalData) {
  @if (data.data == globalData[3].collection) {
    <div class="moving-div move1">
      <div class="black-bg">
        <img src="{{ data[2].real_estate.image_url }}" alt="" class="main-img" />
        @for (item of real_estate; track item; let i = $index) {
          <div
            class="child child-11"
            [ngClass]="{ 'popup-class': popup1 }"
          [ngStyle]="{
            'background-color': !popup2 && !popup3 ? '' : '#ccc',
            filter: !popup2 && !popup3 ? '' : 'grayscale(1)'
          }"
            (click)="triggerClick('one', real_estate[0], 'real_estate')"
            >
            <img
              src="{{ real_estate[0] }}"
              alt=""
              [ngClass]="{ hideShow1: showCheck1 }"
            [ngStyle]="{
              'background-color': !popup2 && !popup3 ? '' : '#ccc',
              filter: !popup2 && !popup3 ? '' : 'grayscale(1)'
            }"
              />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check1" [ngClass]="{ show1: showing1 }" />
            </div>
            <div
              class="child child-12"
              [ngClass]="{ 'popup-class': popup2 }"
          [ngStyle]="{
            'background-color': !popup1 && !popup3 ? '' : '#ccc',
            filter: !popup1 && !popup3 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('two', real_estate[1], 'real_estate')"
              >
              <img src="{{ real_estate[1] }}" alt="" [ngClass]="{ hideShow2: showCheck2 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check2" [ngClass]="{ show2: showing2 }" />
            </div>
            <div
              class="child child-13"
              [ngClass]="{ 'popup-class': popup3 }"
          [ngStyle]="{
            'background-color': !popup1 && !popup2 ? '' : '#ccc',
            filter: !popup1 && !popup2 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('three', real_estate[2], 'real_estate')"
              >
              <img src="{{ real_estate[2] }}" alt="" [ngClass]="{ hideShow3: showCheck3 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check3" [ngClass]="{ show3: showing3 }" />
            </div>
          }
        </div>
      </div>
    }
    @if (data.data == 'garage') {
      <div class="moving-div move2">
        <div class="black-bg">
          <img src="{{ data[2].transport.image_url }}" alt="" class="main-img" />
          @for (item of garage; track item; let i = $index) {
            <div
              class="child child-21"
              [ngClass]="{ 'popup-class': popup1 }"
          [ngStyle]="{
            'background-color': !popup2 && !popup3 ? '' : '#ccc',
            filter: !popup2 && !popup3 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('one', garage[0], 'transport')"
              >
              <img src="{{ garage[0] }}" alt="" [ngClass]="{ hideShow1: showCheck1 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check1" [ngClass]="{ show1: showing1 }" />
            </div>
            <div
              class="child child-22"
              [ngClass]="{ 'popup-class': popup2 }"
          [ngStyle]="{
            'background-color': !popup1 && !popup3 ? '' : '#ccc',
            filter: !popup1 && !popup3 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('two', garage[1], 'transport')"
              >
              <img src="{{ garage[1] }}" alt="" [ngClass]="{ hideShow2: showCheck2 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check2" [ngClass]="{ show2: showing2 }" />
            </div>
            <div
              class="child child-23"
              [ngClass]="{ 'popup-class': popup3 }"
          [ngStyle]="{
            'background-color': !popup1 && !popup2 ? '' : '#ccc',
            filter: !popup1 && !popup2 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('three', garage[2], 'transport')"
              >
              <img src="{{ garage[2] }}" alt="" [ngClass]="{ hideShow3: showCheck3 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check3" [ngClass]="{ show3: showing3 }" />
            </div>
          }
        </div>
      </div>
    }
    @if (data.data == 'bucketList') {
      <div class="moving-div move3">
        <div class="black-bg">
          <img src="{{ data[2].lifestyle.image_url }}" alt="" class="main-img" />
          @for (item of bucket; track item; let i = $index) {
            <div
              class="child child-31"
              [ngClass]="{ 'popup-class': popup1 }"
          [ngStyle]="{
            'background-color': !popup2 && !popup3 ? '' : '#ccc',
            filter: !popup2 && !popup3 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('one', bucket[0], 'lifestyle')"
              >
              <img src="{{ bucket[0] }}" alt="" [ngClass]="{ hideShow1: showCheck1 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check1" [ngClass]="{ show1: showing1 }" />
            </div>
            <div
              class="child child-32"
              [ngClass]="{ 'popup-class': popup2 }"
          [ngStyle]="{
            'background-color': !popup1 && !popup3 ? '' : '#ccc',
            filter: !popup1 && !popup3 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('two', bucket[1], 'lifestyle')"
              >
              <img src="{{ bucket[1] }}" alt="" [ngClass]="{ hideShow2: showCheck2 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check2" [ngClass]="{ show2: showing2 }" />
            </div>
            <div
              class="child child-33"
              [ngClass]="{ 'popup-class': popup3 }"
          [ngStyle]="{
            'background-color': !popup1 && !popup2 ? '' : '#ccc',
            filter: !popup1 && !popup2 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('three', bucket[2], 'lifestyle')"
              >
              <img src="{{ bucket[2] }}" alt="" [ngClass]="{ hideShow3: showCheck3 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check3" [ngClass]="{ show3: showing3 }" />
            </div>
          }
        </div>
      </div>
    }
    @if (data.data == 'holiday') {
      <div class="moving-div move4">
        <div class="black-bg">
          <img src="{{ data[2].holiday.image_url }}" alt="" class="main-img" />
          @for (item of holiday; track item; let i = $index) {
            <div
              class="child child-41"
              [ngClass]="{ 'popup-class': popup1 }"
          [ngStyle]="{
            'background-color': !popup2 && !popup3 ? '' : '#ccc',
            filter: !popup2 && !popup3 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('one', holiday[0], 'holiday')"
              >
              <img src="{{ holiday[0] }}" alt="" [ngClass]="{ hideShow1: showCheck1 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check1" [ngClass]="{ show1: showing1 }" />
            </div>
            <div
              class="child child-42"
              [ngClass]="{ 'popup-class': popup2 }"
          [ngStyle]="{
            'background-color': !popup1 && !popup3 ? '' : '#ccc',
            filter: !popup1 && !popup3 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('two', holiday[1], 'holiday')"
              >
              <img src="{{ holiday[1] }}" alt="" [ngClass]="{ hideShow2: showCheck2 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check2" [ngClass]="{ show2: showing2 }" />
            </div>
            <div
              class="child child-43"
              [ngClass]="{ 'popup-class': popup3 }"
          [ngStyle]="{
            'background-color': !popup1 && !popup2 ? '' : '#ccc',
            filter: !popup1 && !popup2 ? '' : 'grayscale(1)'
          }"
              (click)="triggerClick('three', holiday[2], 'holiday')"
              >
              <img src="{{ holiday[2] }}" alt="" [ngClass]="{ hideShow3: showCheck3 }" />
              <img src="../../../../../assets/icon/check-mark.gif" alt="" class="check3" [ngClass]="{ show3: showing3 }" />
            </div>
          }
        </div>
      </div>
    }
  }
